/** Sdílené React Query klíče submodulu Airlines (napříč okny `list/` a `detail/`). */

import type { QueryClient } from '@tanstack/react-query';
import { getGetInventoryAirlineQueryKey } from '@/api/generated/inventory-airlines/inventory-airlines';

/**
 * Klíč ListPage configu leteckých společností — zároveň prefix React Query klíčů seznamu
 * (`[AIRLINE_LIST_KEY, 'list' | 'stats', …]`). Slouží k invalidaci seznamu po uložení detailu.
 */
export const AIRLINE_LIST_KEY = 'inventory.airlines';

/**
 * Zneplatní detail i seznam po zápisu do letecké společnosti — jediné místo, které tu dvojici zná.
 * Zápis pravidla zavazadel mění obojí (obsah detailu i počet pravidel ve sloupci seznamu), takže by
 * se jinak dala jedna půlka snadno zapomenout.
 * <p>
 * Klíč detailu je Orval URL (lomítka), klíč seznamu tečková notace `config.key` — jeden string
 * match by je nikdy nepokryl oba (viz `frontend/GUIDELINES.md` → antipattern invalidace).
 * </p>
 */
export function invalidateAirline(queryClient: QueryClient, airlineId: number): void {
  void queryClient.invalidateQueries({ queryKey: getGetInventoryAirlineQueryKey(airlineId) });
  void queryClient.invalidateQueries({ queryKey: [AIRLINE_LIST_KEY] });
}
